import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AdminProtectedRoute = () => {
  const { isAuthenticated, user, token } = useSelector((state) => state.auth);
  const storedToken = localStorage.getItem('adminToken') || localStorage.getItem('token');
  const storedUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;

  const currentToken = token || storedToken;
  const currentUser = user || storedUser;

  // Strict Admin Gate: Must have valid token AND role must be admin
  const isAdmin = currentUser && (currentUser.role === 'admin' || currentUser.role === 'Admin');

  if (!currentToken || !isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
